import axiosInstance from "../../../../setup/axios/SetupAxios";

const API_URL = process.env.REACT_APP_BASE_URL;

export const ADD_NEW_KID_URL = `${API_URL}/api/v1/parent/add-kid`;
export const EDIT_CHILD_PROFILE_URL = `${API_URL}/api/v1/parent/edit-details`;
export const EDIT_KID_IMAGE_URL = `${API_URL}/api/v1/parent/kid-image`;
export const DELETE_KID_ACCOUNT_URL = `${API_URL}/api/v1/parent/kid`;

export function addNewKid(payload) {
    return axiosInstance({
        url: ADD_NEW_KID_URL,
        method: "POST",
        data: payload
    })
}

export function editKidProfile(payload) {
    return axiosInstance({
        url: EDIT_CHILD_PROFILE_URL,
        method: "PUT",
        data: payload
    })
}

export function editKidImage(payload) {
    return axiosInstance({
        url: EDIT_KID_IMAGE_URL,
        method: "PUT",
        data: payload
    })
}

export function deleteKidAccount(payload) {
    return axiosInstance({
        url: DELETE_KID_ACCOUNT_URL,
        method: "PUT",
        data: payload
    })
}
